import Cookie from 'utils/cookies';
import {
  TOI_SUBS_CREATE_ORDER_MWEB,
  TOI_SUBS_CREATE_ORDER_WEB,
  TOI_SEO_DOMAIN,
  Plan,
  PRC_FOR_SUBSCRIBED,
} from 'constants/index';
import {
  getPrcCookieValue,
  getUserAccessPayload,
  getGeoCountry,
  getPromiseClientIdCookieValue,
} from '../../../utils/primeUtil';
import alertLogger from '../../../helpers/logAlert/AlertLogger';

const processOrder = async (
  createOrder,
  planId,
  isWapView,
  geoCountry,
  msid = null,
) => {
  const TOI_PLUS_SEO_DOMAIN =
    window.location.origin.indexOf('timesofindia.indiatimes.com') > -1 ||
    window.location.origin.indexOf('m.timesofindia.com') > -1
      ? `${TOI_SEO_DOMAIN}/toi-plus`
      : `${window.location.origin}/toi-plus`;
  const redirectToCurrentPage = () =>
    window.location.href.indexOf('/articleshow') > -1 ||
    window.location.href.indexOf('/printarticle') > -1 ||
    window.location.href.indexOf(
      '/english-news-paper-today-toi-print-edition',
    ) > -1;
  const options = {};
  const currentUrl = window.location.href;
  const currUrlObj = new URL(currentUrl);
  const grxId = Cookie.get('_grx') || '';
  options.ssoId = Cookie.get('ssoid') || Cookie.get('ssoId') || '';
  options.ticketId = Cookie.get('TicketId') || Cookie.get('ticket') || '';
  options.orderType = msid ? 'PAY_PER_ARTICLE' : 'SUBSCRIPTION';
  options.paymentMode = planId === Plan.CRED ? 'CRED' : 'JUSPAY';
  options.productId = planId;
  options.msid = msid || null;
  options.grxId = grxId || null;
  const valueInSs = sessionStorage.getItem('showGstfromNode');
  if (
    typeof window !== 'undefined' &&
    window.sessionStorage &&
    valueInSs &&
    valueInSs === 'true'
  ) {
    options.gstAddressRequired = true;
  } else {
    options.gstAddressRequired = false;
  }
  sessionStorage.removeItem('showGstfromNode');
  if (
    getUserAccessPayload()?.accessType === 'TIMESPRIME' &&
    getUserAccessPayload()?.source === 'tp' &&
    getUserAccessPayload()?.planStatus === PRC_FOR_SUBSCRIBED &&
    getGeoCountry() === 'IN'
  ) {
    options.allowNonNativeDiscount = true;
  }

  let nudgeClickInfo;
  if (
    typeof window !== 'undefined' &&
    window.localStorage &&
    localStorage.getItem('nudgeClickInfo')
  ) {
    nudgeClickInfo = JSON.parse(localStorage.getItem('nudgeClickInfo'));
  }
  options.clientId = (await getPromiseClientIdCookieValue()) || null;
  options.initiationPage = nudgeClickInfo?.initiationPage || null;
  options.nudgeName = nudgeClickInfo?.nudgeName || null;
  options.storyTitle = nudgeClickInfo?.storyTitle || null;
  options.prcStatus = getPrcCookieValue();
  options.initiateMsId = nudgeClickInfo?.msid || null;
  try {
    if (
      !options.clientId ||
      !nudgeClickInfo ||
      !options.initiationPage ||
      !options.nudgeName ||
      (options.initiationPage === 'STORY' &&
        (!options.storyTitle || !options.initiateMsId))
    ) {
      const AlertPreOrderData = {
        options,
        nudgeClickInfo,
      };
      alertLogger('processOrder_Log', AlertPreOrderData);
    }
  } catch (e) {
    console.log('missing parameter in create order', e);
  }
  if (planId === Plan.CRED) {
    const tokenData = JSON.parse(localStorage.getItem('cred_access_token'));
    options.credParams = {
      access_token: tokenData?.access_token,
      refresh_token: tokenData?.refresh_token,
    };
  }

  options.utmParams = {
    source: currUrlObj.searchParams.get('utm_source') || null,
    medium: currUrlObj.searchParams.get('utm_medium') || null,
    campaign: currUrlObj.searchParams.get('utm_campaign') || null,
  };
  if (
    document.referrer &&
    (document.referrer.indexOf('indiatimes.com') > -1 ||
      document.referrer.indexOf('timesofindia.com') > -1)
  ) {
    if (
      currUrlObj.searchParams.get('isPrimeArticle') === 'true' &&
      currUrlObj.searchParams.get('ru')
    ) {
      options.returnUrl = currUrlObj.searchParams.get('ru');
    } else if (currUrlObj.searchParams.get('isPrimeArticle') === 'true') {
      options.returnUrl = document.referrer.replace(
        'amp_articleshow',
        'articleshow',
      );
    } else if (options.orderType === 'PAY_PER_ARTICLE') {
      options.returnUrl = window.location.href;
    } else if (currUrlObj.searchParams.get('isToiPrint') === 'true') {
      options.returnUrl = document.referrer;
    } else if (redirectToCurrentPage()) {
      options.returnUrl = `${currUrlObj.origin}${currUrlObj.pathname}`;
    } else {
      options.returnUrl = TOI_PLUS_SEO_DOMAIN;
    }
  } else if (options.orderType === 'PAY_PER_ARTICLE') {
    options.returnUrl = window.location.href;
  } else if (redirectToCurrentPage()) {
    options.returnUrl = `${currUrlObj.origin}${currUrlObj.pathname}`;
  } else {
    options.returnUrl = TOI_PLUS_SEO_DOMAIN;
  }
  options.headers = {
    ssoId: Cookie.get('ssoid') || Cookie.get('ssoId') || '',
    ticketId: Cookie.get('TicketId') || Cookie.get('ticket') || '',
  };

  const requestUrl = isWapView
    ? TOI_SUBS_CREATE_ORDER_MWEB
    : TOI_SUBS_CREATE_ORDER_WEB;

  return createOrder({
    url: `${requestUrl}&cc=${geoCountry}`,
    options,
  });
};

export default processOrder;
